module.exports = __webpack_public_path__ + "static/media/img2.f8c220cb.jpg";